module.exports = __webpack_public_path__ + "img/microsoft-teams.879b0f25.png";